import React, { useState, useEffect } from 'react';
import { API_URLS } from '../../../config/api';

import { 
  Plus, 
  Edit, 
  Trash2, 
  Eye, 
  EyeOff, 
  Package, 
  Star, 
  Crown,
  CheckCircle,
  XCircle,
  Save,
  X,
  Clock,
  Grid,
  List,
  ChevronDown,
  ChevronRight,
  Check,
  Minus,
  FileText
} from 'lucide-react';

const AdminProEcommercePackages = () => {
  // Tab management
  const [activeTab, setActiveTab] = useState('packages'); // 'packages' or 'comparison'
  
  // Package management
  const [packages, setPackages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [globalFeatures, setGlobalFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);
  const [showGlobalFeaturesModal, setShowGlobalFeaturesModal] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [newFeatureName, setNewFeatureName] = useState('');
  const [timer, setTimer] = useState(null);
  const [timerForm, setTimerForm] = useState({
    title: 'Sınırlı Süreli Kampanya',
    end_date: '',
    is_active: true
  });
  
  // Comparison management
  const [categories, setCategories] = useState([]);
  const [comparisonFeatures, setComparisonFeatures] = useState([]);
  const [featureValues, setFeatureValues] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingFeature, setEditingFeature] = useState(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showFeatureModal, setShowFeatureModal] = useState(false);
  const [selectedCategoryForFeature, setSelectedCategoryForFeature] = useState(null);
  const [selectedPackageForValues, setSelectedPackageForValues] = useState(null);
  const [showPackageValuesModal, setShowPackageValuesModal] = useState(false);
  const [packageFeatureValues, setPackageFeatureValues] = useState({});
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    description: '',
    sort_order: 0
  });
  const [featureForm, setFeatureForm] = useState({
    category_id: '',
    name: '',
    description: '',
    sort_order: 0
  });
  const [formData, setFormData] = useState({
    name: '',
    subtitle: '',
    original_price: '',
    price: '',
    discount: '',
    color: 'from-gray-500 to-gray-700',
    bg_color: 'bg-gray-50',
    icon: 'Package',
    popular: false,
    description: '',
    features: [],
    included_features: [],
    not_included_features: [],
    sort_order: 0,
    url: ''
  });

  const iconOptions = [
    { value: 'Package', label: 'Package', icon: Package },
    { value: 'Star', label: 'Star', icon: Star },
    { value: 'Crown', label: 'Crown', icon: Crown }
  ];

  const colorOptions = [
    { value: 'from-gray-500 to-gray-700', label: 'Gray', bg: 'bg-gray-50' },
    { value: 'from-blue-500 to-blue-700', label: 'Blue', bg: 'bg-blue-50' },
    { value: 'from-green-500 to-green-700', label: 'Green', bg: 'bg-green-50' },
    { value: 'from-purple-500 to-purple-700', label: 'Purple', bg: 'bg-purple-50' },
    { value: 'from-pink-500 to-pink-700', label: 'Pink', bg: 'bg-pink-50' },
    { value: 'from-orange-500 to-orange-700', label: 'Orange', bg: 'bg-orange-50' }
  ];

  useEffect(() => {
    fetchPackages();
    fetchFeatures();
    fetchTimer();
    fetchComparisonData();
  }, []);

  // Global features'i features state'inden al (pro_ecommerce_features tablosundan)
  useEffect(() => {
    if (features && Array.isArray(features)) {
      const featureNames = features
        .filter(f => f && f.title && f.is_active == 1)
        .map(f => f.title);
      setGlobalFeatures(featureNames);
    }
  }, [features]);

  const fetchPackages = async () => {
    try {
      const response = await fetch(API_URLS.ADMIN.PRO_ECOMMERCE_PACKAGES);
      const result = await response.json();
      
      console.log('Pro E-commerce packages API response:', result);
      
      let pkgs = [];
      if (result.status === 'success') {
        pkgs = result.data || [];
      } else if (Array.isArray(result)) {
        pkgs = result;
      }
      
      console.log('Pro E-commerce packages loaded:', pkgs.length);
      setPackages(pkgs);
      
      // Global özellikleri pro_ecommerce_features tablosundan yükle
      // (Artık paketlerin features JSON'ından değil, tablodan çekiyoruz)
      
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFeatures = async () => {
    try {
      const response = await fetch(API_URLS.ADMIN.PRO_ECOMMERCE_FEATURES);
      const result = await response.json();
      if (result.status === 'success') {
        setFeatures(result.data);
      }
    } catch (error) {
      console.error('Error fetching features:', error);
    }
  };

  const fetchTimer = async () => {
    try {
      const response = await fetch(API_URLS.ADMIN.GET_PRO_ECOMMERCE_TIMER);
      const result = await response.json();
      if (result.status === 'success' && result.data) {
        setTimer(result.data);
        setTimerForm({
          title: result.data.title || 'Sınırlı Süreli Kampanya',
          end_date: result.data.end_date ? result.data.end_date.slice(0, 16) : '',
          is_active: result.data.is_active == 1
        });
      }
    } catch (error) {
      console.error('Error fetching timer:', error);
    }
  };

  const handleSaveTimer = async () => {
    try {
      const payload = {
        id: timer?.id || 1,
        title: timerForm.title,
        end_date: timerForm.end_date,
        is_active: timerForm.is_active
      };
      
      console.log('Sending timer update:', payload);
      
      const response = await fetch(API_URLS.ADMIN.UPDATE_PRO_ECOMMERCE_TIMER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      
      console.log('Timer update result:', result);
      
      if (result.status === 'success') {
        alert('Timer başarıyla güncellendi!');
        fetchTimer();
      } else {
        alert('Hata: ' + (result.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Error saving timer:', error);
      alert('Timer kaydedilirken hata oluştu');
    }
  };

  // ============================================
  // COMPARISON MANAGEMENT FUNCTIONS
  // ============================================

  const fetchComparisonData = async () => {
    try {
      // Fetch categories
      const categoriesResponse = await fetch(API_URLS.ADMIN.GET_PRO_FEATURE_CATEGORIES);
      const categoriesResult = await categoriesResponse.json();
      if (categoriesResult.status === 'success') {
        setCategories(categoriesResult.data || []);
        
        // Initialize expanded state for all categories
        const expanded = {};
        (categoriesResult.data || []).forEach(cat => {
          expanded[cat.id] = false;
        });
        setExpandedCategories(expanded);
      }

      // Fetch all features
      const featuresResponse = await fetch(API_URLS.ADMIN.GET_PRO_PACKAGE_FEATURES_LIST);
      
      if (!featuresResponse.ok) {
        console.error('Features response not OK:', featuresResponse.status);
        return;
      }
      
      const featuresResult = await featuresResponse.json();
      console.log('Comparison features result:', featuresResult);
      
      if (featuresResult.status === 'success') {
        const features = featuresResult.data || [];
        console.log('Setting comparison features:', features.length);
        setComparisonFeatures(features);
      } else {
        console.error('Features fetch failed:', featuresResult.message);
      }
    } catch (error) {
      console.error('Error fetching comparison data:', error);
    }
  };

  const handleSaveCategory = async (e) => {
    e.preventDefault();
    try {
      const url = editingCategory 
        ? API_URLS.ADMIN.UPDATE_PRO_FEATURE_CATEGORY 
        : API_URLS.ADMIN.CREATE_PRO_FEATURE_CATEGORY;
      
      const payload = editingCategory 
        ? { ...categoryForm, id: editingCategory.id }
        : categoryForm;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.status === 'success') {
        alert(editingCategory ? 'Kategori güncellendi!' : 'Kategori oluşturuldu!');
        setShowCategoryModal(false);
        setEditingCategory(null);
        setCategoryForm({ name: '', description: '', sort_order: 0 });
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving category:', error);
      alert('Kategori kaydedilirken hata oluştu');
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!confirm('Bu kategori ve altındaki tüm özellikler silinecek. Emin misiniz?')) return;
    
    try {
      const response = await fetch(API_URLS.ADMIN.DELETE_PRO_FEATURE_CATEGORY(categoryId));
      const result = await response.json();
      
      if (result.status === 'success') {
        alert('Kategori silindi!');
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      alert('Kategori silinirken hata oluştu');
    }
  };

  const handleEditCategory = (category) => {
    setEditingCategory(category);
    setCategoryForm({
      name: category.name,
      description: category.description || '',
      sort_order: category.sort_order || 0
    });
    setShowCategoryModal(true);
  };

  const handleSaveFeature = async (e) => {
    e.preventDefault();
    try {
      const url = editingFeature 
        ? API_URLS.ADMIN.UPDATE_PRO_PACKAGE_FEATURE 
        : API_URLS.ADMIN.CREATE_PRO_PACKAGE_FEATURE;
      
      const payload = editingFeature 
        ? { ...featureForm, id: editingFeature.id }
        : featureForm;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        alert(editingFeature ? 'Özellik güncellendi!' : 'Özellik oluşturuldu!');
        setShowFeatureModal(false);
        setEditingFeature(null);
        setSelectedCategoryForFeature(null);
        setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
        fetchComparisonData();
      } else {
        alert('Hata: ' + (result.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Error saving feature:', error);
      const errorMessage = error.message || 'Bilinmeyen hata';
      alert('Özellik kaydedilirken hata oluştu: ' + errorMessage);
      
      // Debug için response'u logla
      if (error.message.includes('Empty response')) {
        console.error('Backend returned empty response. Check if endpoint exists:', url);
      }
    }
  };

  const handleDeleteFeature = async (featureId) => {
    if (!confirm('Bu özellik silinecek. Emin misiniz?')) return;
    
    try {
      const response = await fetch(API_URLS.ADMIN.DELETE_PRO_PACKAGE_FEATURE(featureId));
      const result = await response.json();
      
      if (result.status === 'success') {
        alert('Özellik silindi!');
        fetchComparisonData();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting feature:', error);
      alert('Özellik silinirken hata oluştu');
    }
  };

  const handleEditFeature = (feature) => {
    setEditingFeature(feature);
    setFeatureForm({
      category_id: feature.category_id,
      name: feature.name,
      description: feature.description || '',
      sort_order: feature.sort_order || 0
    });
    setShowFeatureModal(true);
  };

  const handleAddFeatureToCategory = (categoryId) => {
    setSelectedCategoryForFeature(categoryId);
    setFeatureForm({
      category_id: categoryId,
      name: '',
      description: '',
      sort_order: 0
    });
    setShowFeatureModal(true);
  };

  const toggleCategoryExpanded = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const handleManagePackageValues = async (pkg) => {
    setSelectedPackageForValues(pkg);
    setShowPackageValuesModal(true);
    
    // Fetch existing values for this package
    try {
      const url = `${API_URLS.ADMIN.GET_PRO_PACKAGE_FEATURE_VALUES}&package_id=${pkg.id}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        console.warn('Empty response from server');
        setPackageFeatureValues({});
        return;
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        // Convert array to object keyed by feature_id for easier lookup
        const valuesMap = {};
        if (result.data && Array.isArray(result.data)) {
          result.data.forEach(val => {
            valuesMap[val.feature_id] = {
              value_type: val.value_type,
              value_text: val.value_text
            };
          });
        }
        setPackageFeatureValues(valuesMap);
      }
    } catch (error) {
      console.error('Error fetching package feature values:', error);
      setPackageFeatureValues({});
    }
  };

  const handleFeatureValueChange = (featureId, valueType) => {
    setPackageFeatureValues(prev => ({
      ...prev,
      [featureId]: {
        value_type: valueType,
        value_text: valueType === 'text' ? (prev[featureId]?.value_text || '') : null
      }
    }));
  };

  const handleFeatureValueTextChange = (featureId, text) => {
    setPackageFeatureValues(prev => ({
      ...prev,
      [featureId]: {
        ...prev[featureId],
        value_text: text
      }
    }));
  };

  const handleSavePackageFeatureValues = async () => {
    if (!selectedPackageForValues) return;

    try {
      // Convert object back to array
      const values = Object.entries(packageFeatureValues).map(([featureId, data]) => ({
        feature_id: parseInt(featureId),
        value_type: data.value_type,
        value_text: data.value_text
      }));

      const response = await fetch(API_URLS.ADMIN.SAVE_PRO_PACKAGE_FEATURE_VALUES, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          package_id: selectedPackageForValues.id,
          values: values
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const text = await response.text();
      if (!text || text.trim() === '') {
        throw new Error('Empty response from server');
      }
      
      const result = JSON.parse(text);
      
      if (result.status === 'success') {
        alert('Paket özellikleri başarıyla kaydedildi!');
        
        // Reload the values for this package to show updated data
        const reloadUrl = `${API_URLS.ADMIN.GET_PRO_PACKAGE_FEATURE_VALUES}&package_id=${selectedPackageForValues.id}`;
        const valuesResponse = await fetch(reloadUrl);
        const valuesResult = await valuesResponse.json();
        
        if (valuesResult.status === 'success') {
          // Convert array to object keyed by feature_id for easier lookup
          const valuesMap = {};
          valuesResult.data.forEach(val => {
            valuesMap[val.feature_id] = {
              value_type: val.value_type,
              value_text: val.value_text
            };
          });
          setPackageFeatureValues(valuesMap);
        }
        
        // Optionally close the modal (comment out to keep it open)
        // setShowPackageValuesModal(false);
        // setSelectedPackageForValues(null);
        // setPackageFeatureValues({});
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving package feature values:', error);
      alert('Paket özellikleri kaydedilirken hata oluştu');
    }
  };


  const addGlobalFeature = async (featureName) => {
    if (!featureName.trim()) return;
    
    try {
      // pro_ecommerce_features tablosuna yeni özellik ekle
      const response = await fetch(API_URLS.ADMIN.CREATE_PRO_ECOMMERCE_FEATURE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: featureName,
          description: '',
          icon: 'CheckCircle',
          value: null,
          sort_order: features.length
        })
      });

      const result = await response.json();
      if (result.status === 'success') {
        // Features listesini yenile
        fetchFeatures();
        setNewFeatureName('');
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error creating feature:', error);
      alert('Özellik eklenirken hata oluştu');
    }
  };

  const deleteGlobalFeature = async (featureName) => {
    if (!confirm(`"${featureName}" özelliği silinecek. Emin misiniz?`)) return;

    try {
      // Özelliği features listesinden bul
      const feature = features.find(f => f && f.title === featureName);
      if (!feature || !feature.id) {
        alert('Özellik bulunamadı');
        return;
      }

      // pro_ecommerce_features tablosundan sil
      const response = await fetch(`${API_URLS.ADMIN.DELETE_PRO_ECOMMERCE_FEATURE}&feature_id=${feature.id}`);
      const result = await response.json();

      if (result.status === 'success') {
        // Features listesini yenile
        fetchFeatures();
      } else {
        alert('Hata: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting feature:', error);
      alert('Özellik silinirken hata oluştu');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingPackage 
        ? API_URLS.ADMIN.UPDATE_PRO_ECOMMERCE_PACKAGE 
        : API_URLS.ADMIN.CREATE_PRO_ECOMMERCE_PACKAGE;
      
      const method = editingPackage ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          id: editingPackage?.id
        }),
      });

      const result = await response.json();
      if (result.status === 'success') {
        fetchPackages();
        setShowModal(false);
        resetForm();
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error saving package:', error);
      alert('Error saving package');
    }
  };

  const handleEdit = (pkg) => {
    setEditingPackage(pkg);
    setFormData({
      name: pkg.name || '',
      subtitle: pkg.subtitle || '',
      original_price: pkg.original_price || '',
      price: pkg.price || '',
      discount: pkg.discount || '',
      color: pkg.color || 'from-gray-500 to-gray-700',
      bg_color: pkg.bg_color || 'bg-gray-50',
      icon: pkg.icon || 'Package',
      popular: pkg.popular == 1,
      description: pkg.description || '',
      features: pkg.features ? JSON.parse(pkg.features) : [],
      included_features: pkg.included_features ? JSON.parse(pkg.included_features) : [],
      not_included_features: pkg.not_included_features ? JSON.parse(pkg.not_included_features) : [],
      sort_order: pkg.sort_order || 0,
      url: pkg.url || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (packageId) => {
    if (window.confirm('Are you sure you want to delete this package?')) {
      try {
        const response = await fetch(`${API_URLS.ADMIN.DELETE_PRO_ECOMMERCE_PACKAGE}&package_id=${packageId}`);
        const result = await response.json();
        if (result.status === 'success') {
          fetchPackages();
        } else {
          alert('Error: ' + result.message);
        }
      } catch (error) {
        console.error('Error deleting package:', error);
        alert('Error deleting package');
      }
    }
  };

  const handleToggleStatus = async (packageId) => {
    try {
      const response = await fetch(`${API_URLS.ADMIN.TOGGLE_PRO_ECOMMERCE_PACKAGE_STATUS}&package_id=${packageId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const result = await response.json();
      if (result.status === 'success') {
        fetchPackages();
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
      alert('Error toggling status: ' + error.message);
    }
  };

  const handleManageFeatures = async (pkg) => {
    setSelectedPackage(pkg);
    setShowFeaturesModal(true);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      subtitle: '',
      original_price: '',
      price: '',
      discount: '',
      color: 'from-gray-500 to-gray-700',
      bg_color: 'bg-gray-50',
      icon: 'Package',
      popular: false,
      description: '',
      features: [],
      included_features: [],
      not_included_features: [],
      sort_order: 0,
      url: ''
    });
    setEditingPackage(null);
  };

  const getIconComponent = (iconName) => {
    const iconOption = iconOptions.find(opt => opt.value === iconName);
    return iconOption ? iconOption.icon : Package;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Profesyonel E-Ticaret Paketleri</h1>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab('packages')}
            className={`pb-3 px-4 font-medium border-b-2 transition-colors flex items-center gap-2 ${
              activeTab === 'packages'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Package className="w-4 h-4" />
            Paketler
          </button>
          <button
            onClick={() => setActiveTab('comparison')}
            className={`pb-3 px-4 font-medium border-b-2 transition-colors flex items-center gap-2 ${
              activeTab === 'comparison'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Grid className="w-4 h-4" />
            Paket Karşılaştırma
          </button>
        </div>
      </div>

      {/* Packages Tab */}
      {activeTab === 'packages' && (
        <>
          <div className="flex justify-end items-center mb-6 gap-2">
            <button
              onClick={() => setShowGlobalFeaturesModal(true)}
              className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
            >
              <CheckCircle className="w-4 h-4" />
              Global Özellikler ({globalFeatures.length})
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <Plus className="w-4 h-4" />
              Yeni Paket
            </button>
          </div>

      {/* Timer Yönetimi */}
      <div className="mb-6 bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-lg p-6">
        <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <Clock className="w-5 h-5 text-orange-600" />
          Kampanya Geri Sayım Timer
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Başlık</label>
            <input
              type="text"
              value={timerForm.title}
              onChange={(e) => setTimerForm({...timerForm, title: e.target.value})}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="Sınırlı Süreli Kampanya"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Bitiş Tarihi</label>
            <input
              type="datetime-local"
              value={timerForm.end_date}
              onChange={(e) => setTimerForm({...timerForm, end_date: e.target.value})}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <div className="flex items-end gap-2">
            <label className="flex items-center gap-2 flex-1">
              <input
                type="checkbox"
                checked={timerForm.is_active}
                onChange={(e) => setTimerForm({...timerForm, is_active: e.target.checked})}
                className="rounded border-gray-300 text-orange-600 focus:ring-orange-500"
              />
              <span className="text-sm font-medium text-gray-700">Aktif</span>
            </label>
            <button
              onClick={handleSaveTimer}
              className="bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 flex items-center gap-2"
            >
              <Save className="w-4 h-4" />
              Kaydet
            </button>
          </div>
        </div>
      </div>

      {packages.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
          <Package className="w-12 h-12 mx-auto mb-4 text-gray-400" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Henüz paket yok</h3>
          <p className="text-gray-600 mb-4">
            Profesyonel e-ticaret paketleri eklemek için "Yeni Paket" butonuna tıklayın
          </p>
          <button
            onClick={() => setShowModal(true)}
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            <Plus className="w-4 h-4" />
            İlk Paketi Ekle
          </button>
        </div>
      ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages.map((pkg) => {
          const IconComponent = getIconComponent(pkg.icon);
          return (
            <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className={`h-2 bg-gradient-to-r ${pkg.color || 'from-gray-500 to-gray-700'}`}></div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg bg-gradient-to-r ${pkg.color || 'from-gray-500 to-gray-700'} text-white`}>
                      <IconComponent className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">{pkg.name || 'İsimsiz Paket'}</h3>
                      {pkg.popular == 1 && (
                        <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                          Popüler
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleToggleStatus(pkg.id)}
                      className={`p-2 rounded-lg ${pkg.is_active == 1 ? 'text-green-600 hover:bg-green-50' : 'text-gray-400 hover:bg-gray-50'}`}
                    >
                      {pkg.is_active == 1 ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                    </button>
                    <button
                      onClick={() => handleEdit(pkg)}
                      className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg"
                    >
                      <Edit className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => handleDelete(pkg.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  {pkg.subtitle && (
                    <p className="text-sm text-gray-600 mb-2">{pkg.subtitle}</p>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-gray-900">₺{parseFloat(pkg.price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    {parseFloat(pkg.original_price || 0) > parseFloat(pkg.price || 0) && (
                      <span className="text-sm text-gray-500 line-through">₺{parseFloat(pkg.original_price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    )}
                    {parseFloat(pkg.discount || 0) > 0 && (
                      <span className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">
                        %{pkg.discount} İndirim
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  {pkg.description && (
                    <p className="text-sm text-gray-600">{pkg.description}</p>
                  )}
                  {pkg.url && (
                    <div className="mt-2 flex items-center gap-2">
                      <span className="text-xs text-gray-500">URL:</span>
                      <a 
                        href={pkg.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-xs text-blue-600 hover:underline truncate"
                      >
                        {pkg.url}
                      </a>
                    </div>
                  )}
                </div>

              </div>
            </div>
          );
        })}
      </div>
      )}
        </>
      )}

      {/* Comparison Tab */}
      {activeTab === 'comparison' && (
        <div className="space-y-6">
          {/* Paket Listesi - Özellik Değerleri Yönetimi */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 sm:p-6">
            <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
              <Package className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
              Paket Özellik Değerleri Yönetimi
            </h2>
            <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 break-words">
              Her paket için karşılaştırma tablosunda gösterilecek özellik değerlerini belirleyin
            </p>
            
            {packages.length === 0 ? (
              <div className="text-center py-6 sm:py-8 bg-white rounded-lg border-2 border-dashed border-gray-300">
                <Package className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2 text-gray-400" />
                <p className="text-sm sm:text-base text-gray-600 break-words px-2">Henüz paket yok. Önce "Paketler" sekmesinden paket ekleyin.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                {packages.map((pkg) => {
                  const IconComponent = getIconComponent(pkg.icon);
                  return (
                    <div key={pkg.id} className="bg-white rounded-lg shadow border border-gray-200 p-3 sm:p-4 hover:shadow-md transition-shadow">
                      <div className="flex items-center gap-2 sm:gap-3 mb-3">
                        <div className={`p-2 rounded-lg bg-gradient-to-r ${pkg.color || 'from-gray-500 to-gray-700'} text-white flex-shrink-0`}>
                          <IconComponent className="w-4 h-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-sm sm:text-base text-gray-900 break-words">{pkg.name}</h3>
                          {pkg.category && (
                            <p className="text-xs text-gray-500 break-words">{pkg.category}</p>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() => handleManagePackageValues(pkg)}
                        className="w-full bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 text-xs sm:text-sm"
                      >
                        <Grid className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                        <span className="break-words">Özellik Değerleri</span>
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Kategori ve Özellik Yönetimi */}
          <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 sm:gap-4">
            <h2 className="text-base sm:text-lg font-bold text-gray-900">Kategoriler ve Özellikler</h2>
            <button
              onClick={() => {
                setEditingCategory(null);
                setCategoryForm({ name: '', description: '', sort_order: 0 });
                setShowCategoryModal(true);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              <Plus className="w-4 h-4 flex-shrink-0" />
              <span>Yeni Kategori</span>
            </button>
          </div>

          {/* Categories List */}
          {categories.length === 0 ? (
            <div className="text-center py-8 sm:py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 px-4">
              <List className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 text-gray-400" />
              <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2 break-words">Henüz kategori yok</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 break-words px-2">
                Paket karşılaştırma tablosu için kategoriler ve özellikler ekleyin
              </p>
              <button
                onClick={() => setShowCategoryModal(true)}
                className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 w-full sm:w-auto justify-center"
              >
                <Plus className="w-4 h-4 flex-shrink-0" />
                <span>İlk Kategoriyi Ekle</span>
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {categories.map((category) => {
                const categoryFeatures = comparisonFeatures.filter(
                  f => f.category_id === category.id
                );
                const isExpanded = expandedCategories[category.id];

                return (
                  <div key={category.id} className="bg-white rounded-lg shadow border border-gray-200">
                    <div className="p-3 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-2 bg-gray-50 rounded-t-lg">
                      <div className="flex items-center gap-2 sm:gap-3 flex-1 w-full sm:w-auto min-w-0">
                        <button
                          onClick={() => toggleCategoryExpanded(category.id)}
                          className="p-1 hover:bg-gray-200 rounded flex-shrink-0"
                        >
                          {isExpanded ? (
                            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
                          ) : (
                            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
                          )}
                        </button>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-base sm:text-lg text-gray-900 break-words">{category.name}</h3>
                          {category.description && (
                            <p className="text-xs sm:text-sm text-gray-600 break-words mt-1">{category.description}</p>
                          )}
                        </div>
                        <span className="ml-auto sm:ml-0 text-xs sm:text-sm text-gray-500 bg-white px-2 sm:px-3 py-1 rounded-full flex-shrink-0">
                          {categoryFeatures.length} özellik
                        </span>
                      </div>
                      <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                        <button
                          onClick={() => handleAddFeatureToCategory(category.id)}
                          className="p-2 text-green-600 hover:bg-green-50 rounded-lg flex-shrink-0"
                          title="Özellik Ekle"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleEditCategory(category)}
                          className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg flex-shrink-0"
                          title="Düzenle"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleDeleteCategory(category.id)}
                          className="p-2 text-red-600 hover:bg-red-50 rounded-lg flex-shrink-0"
                          title="Sil"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>

                    {/* Features List */}
                    {isExpanded && (
                      <div className="p-3 sm:p-4 space-y-2">
                        {categoryFeatures.length === 0 ? (
                          <div className="text-center py-6 sm:py-8 text-gray-500">
                            <FileText className="w-6 h-6 sm:w-8 sm:h-8 mx-auto mb-2 opacity-50" />
                            <p className="text-xs sm:text-sm break-words px-2">Bu kategoride henüz özellik yok</p>
                            <button
                              onClick={() => handleAddFeatureToCategory(category.id)}
                              className="mt-2 text-blue-600 hover:underline text-xs sm:text-sm"
                            >
                              + Özellik Ekle
                            </button>
                          </div>
                        ) : (
                          categoryFeatures.map((feature) => (
                            <div
                              key={feature.id}
                              className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-0 p-3 bg-gray-50 rounded-lg hover:bg-gray-100"
                            >
                              <div className="flex-1 min-w-0 w-full sm:w-auto">
                                <h4 className="font-medium text-sm sm:text-base text-gray-900 break-words">{feature.name}</h4>
                                {feature.description && (
                                  <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{feature.description}</p>
                                )}
                              </div>
                              <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                                <button
                                  onClick={() => handleEditFeature(feature)}
                                  className="p-1 text-blue-600 hover:text-blue-700 flex-shrink-0"
                                  title="Düzenle"
                                >
                                  <Edit className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteFeature(feature.id)}
                                  className="p-1 text-red-600 hover:text-red-700 flex-shrink-0"
                                  title="Sil"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Package Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingPackage ? 'Paketi Düzenle' : 'Yeni Paket'}
              </h2>
              <button
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Paket Adı</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Alt Başlık</label>
                  <input
                    type="text"
                    value={formData.subtitle}
                    onChange={(e) => setFormData({...formData, subtitle: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Orijinal Fiyat</label>
                  <input
                    type="number"
                    value={formData.original_price}
                    onChange={(e) => setFormData({...formData, original_price: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fiyat</label>
                  <input
                    type="number"
                    value={formData.price}
                    onChange={(e) => setFormData({...formData, price: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">İndirim (%)</label>
                  <input
                    type="number"
                    value={formData.discount}
                    onChange={(e) => setFormData({...formData, discount: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Renk</label>
                  <select
                    value={formData.color}
                    onChange={(e) => {
                      const selectedColor = colorOptions.find(opt => opt.value === e.target.value);
                      setFormData({
                        ...formData, 
                        color: e.target.value,
                        bg_color: selectedColor?.bg || 'bg-gray-50'
                      });
                    }}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {colorOptions.map((color) => (
                      <option key={color.value} value={color.value}>
                        {color.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">İkon</label>
                  <select
                    value={formData.icon}
                    onChange={(e) => setFormData({...formData, icon: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {iconOptions.map((icon) => (
                      <option key={icon.value} value={icon.value}>
                        {icon.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Açıklama</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Satın Alma URL</label>
                <input
                  type="url"
                  value={formData.url}
                  onChange={(e) => setFormData({...formData, url: e.target.value})}
                  placeholder="https://example.com/checkout"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500 mt-1">Pakete tıklandığında yönlendirilecek URL</p>
              </div>

              {/* Features Management */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Özellikler
                  <span className="text-xs text-gray-500 ml-2">
                    (Global özelliklerden seçin)
                  </span>
                </label>
                {globalFeatures.length === 0 ? (
                  <div className="text-center py-6 border border-gray-200 rounded-lg bg-gray-50">
                    <p className="text-sm text-gray-600">
                      Önce global özellikler ekleyin
                    </p>
                    <button
                      type="button"
                      onClick={() => {
                        setShowModal(false);
                        setShowGlobalFeaturesModal(true);
                      }}
                      className="mt-2 text-blue-600 hover:underline text-sm"
                    >
                      Global Özellikler Sayfasına Git
                    </button>
                  </div>
                ) : (
                  <div className="space-y-2 max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-3">
                    {globalFeatures.map((featureName, index) => {
                      const isIncluded = formData.features.some(f => f.name === featureName && f.included);
                      return (
                        <div key={index} className="flex items-center gap-2 bg-gray-50 p-2 rounded">
                          <input
                            type="checkbox"
                            checked={isIncluded}
                            onChange={(e) => {
                              let newFeatures = [...formData.features];
                              const existingIndex = newFeatures.findIndex(f => f.name === featureName);
                              
                              if (existingIndex >= 0) {
                                newFeatures[existingIndex].included = e.target.checked;
                              } else {
                                newFeatures.push({ name: featureName, included: e.target.checked });
                              }
                              
                              setFormData({...formData, features: newFeatures});
                            }}
                            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                          />
                          <span className="flex-1 text-gray-900">{featureName}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="popular"
                  checked={formData.popular}
                  onChange={(e) => setFormData({...formData, popular: e.target.checked})}
                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <label htmlFor="popular" className="text-sm font-medium text-gray-700">
                  Popüler Paket
                </label>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Global Features Modal */}
      {showGlobalFeaturesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Global Özellikler Yönetimi</h2>
              <button
                onClick={() => setShowGlobalFeaturesModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-blue-800">
                <strong>Önemli:</strong> Buradan eklediğiniz özellikler tüm paketlere otomatik olarak eklenir.
                Sildiğiniz özellikler tüm paketlerden silinir.
              </p>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yeni Özellik Ekle
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={newFeatureName}
                  onChange={(e) => setNewFeatureName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      addGlobalFeature(newFeatureName);
                    }
                  }}
                  placeholder="Özellik adı..."
                  className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  onClick={() => addGlobalFeature(newFeatureName)}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Plus className="w-4 h-4" />
                  Ekle
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mevcut Özellikler ({globalFeatures.length})
              </label>
              {globalFeatures.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Package className="w-12 h-12 mx-auto mb-2 opacity-50" />
                  <p>Henüz özellik eklenmemiş</p>
                </div>
              ) : (
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {globalFeatures.map((feature, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between bg-gray-50 p-3 rounded-lg hover:bg-gray-100"
                    >
                      <span className="text-gray-900 font-medium">{feature}</span>
                      <button
                        onClick={() => deleteGlobalFeature(feature)}
                        className="text-red-600 hover:text-red-700 p-1"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowGlobalFeaturesModal(false)}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Category Modal */}
      {showCategoryModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingCategory ? 'Kategoriyi Düzenle' : 'Yeni Kategori'}
              </h2>
              <button
                onClick={() => {
                  setShowCategoryModal(false);
                  setEditingCategory(null);
                  setCategoryForm({ name: '', description: '', sort_order: 0 });
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSaveCategory} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Kategori Adı
                </label>
                <input
                  type="text"
                  value={categoryForm.name}
                  onChange={(e) => setCategoryForm({...categoryForm, name: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Genel Özellikler"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Açıklama
                </label>
                <textarea
                  value={categoryForm.description}
                  onChange={(e) => setCategoryForm({...categoryForm, description: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Kategori açıklaması..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sıralama
                </label>
                <input
                  type="number"
                  value={categoryForm.sort_order}
                  onChange={(e) => setCategoryForm({...categoryForm, sort_order: parseInt(e.target.value) || 0})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="0"
                />
                <p className="text-xs text-gray-500 mt-1">Küçük sayılar önce gösterilir</p>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowCategoryModal(false);
                    setEditingCategory(null);
                    setCategoryForm({ name: '', description: '', sort_order: 0 });
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Feature Modal */}
      {showFeatureModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingFeature ? 'Özelliği Düzenle' : 'Yeni Özellik'}
              </h2>
              <button
                onClick={() => {
                  setShowFeatureModal(false);
                  setEditingFeature(null);
                  setSelectedCategoryForFeature(null);
                  setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSaveFeature} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Kategori
                </label>
                <select
                  value={featureForm.category_id}
                  onChange={(e) => setFeatureForm({...featureForm, category_id: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  disabled={!!selectedCategoryForFeature}
                >
                  <option value="">Kategori seçin...</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Özellik Adı
                </label>
                <input
                  type="text"
                  value={featureForm.name}
                  onChange={(e) => setFeatureForm({...featureForm, name: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="7/24 Destek & Eğitim"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Açıklama
                </label>
                <textarea
                  value={featureForm.description}
                  onChange={(e) => setFeatureForm({...featureForm, description: e.target.value})}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Özellik açıklaması..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sıralama
                </label>
                <input
                  type="number"
                  value={featureForm.sort_order}
                  onChange={(e) => setFeatureForm({...featureForm, sort_order: parseInt(e.target.value) || 0})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="0"
                />
                <p className="text-xs text-gray-500 mt-1">Küçük sayılar önce gösterilir</p>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowFeatureModal(false);
                    setEditingFeature(null);
                    setSelectedCategoryForFeature(null);
                    setFeatureForm({ category_id: '', name: '', description: '', sort_order: 0 });
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Package Feature Values Modal */}
      {showPackageValuesModal && selectedPackageForValues && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-white rounded-lg w-full max-w-[95vw] sm:max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0 p-4 sm:p-6 border-b border-gray-200">
              <div className="flex-1 min-w-0">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 break-words">
                  {selectedPackageForValues.name} - Özellik Değerleri
                </h2>
                <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">
                  Her özellik için bir değer tipi seçin
                </p>
              </div>
              <button
                onClick={() => {
                  setShowPackageValuesModal(false);
                  setSelectedPackageForValues(null);
                  setPackageFeatureValues({});
                }}
                className="text-gray-500 hover:text-gray-700 flex-shrink-0 self-end sm:self-auto"
              >
                <X className="w-5 h-5 sm:w-6 sm:h-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-3 sm:p-6">
              {comparisonFeatures.length === 0 ? (
                <div className="text-center py-8 sm:py-12">
                  <FileText className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 sm:mb-4 text-gray-400" />
                  <p className="text-sm sm:text-base text-gray-600 mb-2 break-words">Henüz özellik yok</p>
                  <p className="text-xs sm:text-sm text-gray-500 break-words px-2">
                    Önce kategoriler ve özellikler oluşturun
                  </p>
                </div>
              ) : (
                <div className="space-y-4 sm:space-y-6">
                  {categories.map((category) => {
                    const categoryFeatures = comparisonFeatures.filter(
                      f => f.category_id === category.id
                    );
                    
                    if (categoryFeatures.length === 0) return null;

                    return (
                      <div key={category.id} className="border border-gray-200 rounded-lg overflow-hidden">
                        <div className="bg-gray-100 px-3 sm:px-4 py-2 sm:py-3 border-b border-gray-200">
                          <h3 className="font-bold text-sm sm:text-base text-gray-900 break-words">{category.name}</h3>
                          {category.description && (
                            <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{category.description}</p>
                          )}
                        </div>
                        <div className="divide-y divide-gray-200">
                          {categoryFeatures.map((feature) => {
                            const currentValue = packageFeatureValues[feature.id] || { value_type: 'cross', value_text: null };
                            
                            return (
                              <div key={feature.id} className="p-3 sm:p-4 hover:bg-gray-50">
                                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                                  <div className="flex-1 min-w-0 w-full sm:w-auto">
                                    <h4 className="font-medium text-sm sm:text-base text-gray-900 break-words">{feature.name}</h4>
                                    {feature.description && (
                                      <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">{feature.description}</p>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
                                    <button
                                      onClick={() => handleFeatureValueChange(feature.id, 'check')}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'check'
                                          ? 'bg-green-100 text-green-600 ring-2 ring-green-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-green-50'
                                      }`}
                                      title="Var"
                                    >
                                      <Check className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                    <button
                                      onClick={() => handleFeatureValueChange(feature.id, 'cross')}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'cross'
                                          ? 'bg-red-100 text-red-600 ring-2 ring-red-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-red-50'
                                      }`}
                                      title="Yok"
                                    >
                                      <X className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                    <button
                                      onClick={() => handleFeatureValueChange(feature.id, 'optional')}
                                      className={`p-2 rounded-lg transition-colors flex-shrink-0 ${
                                        currentValue.value_type === 'optional'
                                          ? 'bg-orange-100 text-orange-600 ring-2 ring-orange-500'
                                          : 'bg-gray-100 text-gray-400 hover:bg-orange-50'
                                      }`}
                                      title="İsteğe Bağlı"
                                    >
                                      <Minus className="w-4 h-4 sm:w-5 sm:h-5" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 p-4 sm:p-6 border-t border-gray-200 bg-gray-50">
              <div className="flex flex-wrap items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-600 justify-center sm:justify-start">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-green-100 text-green-600 rounded flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>Var</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-red-100 text-red-600 rounded flex items-center justify-center flex-shrink-0">
                    <X className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>Yok</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-orange-100 text-orange-600 rounded flex items-center justify-center flex-shrink-0">
                    <Minus className="w-3 h-3 sm:w-4 sm:h-4" />
                  </div>
                  <span>İsteğe Bağlı</span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
                <button
                  onClick={() => {
                    setShowPackageValuesModal(false);
                    setSelectedPackageForValues(null);
                    setPackageFeatureValues({});
                  }}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 w-full sm:w-auto"
                >
                  İptal
                </button>
                <button
                  onClick={handleSavePackageFeatureValues}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  <Save className="w-4 h-4 flex-shrink-0" />
                  Kaydet
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Features Modal */}
      {showFeaturesModal && selectedPackage && (
        <PackageFeaturesModal
          package={selectedPackage}
          features={features}
          onClose={() => {
            setShowFeaturesModal(false);
            setSelectedPackage(null);
          }}
          onUpdate={fetchPackages}
        />
      )}
    </div>
  );
};

// Package Features Modal Component
const PackageFeaturesModal = ({ package: pkg, features, onClose, onUpdate }) => {
  const [packageFeatures, setPackageFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackageFeatures();
  }, [pkg.id]);

  const fetchPackageFeatures = async () => {
    try {
      const response = await fetch(`${API_URLS.ADMIN.GET_PRO_PACKAGE_FEATURES}&package_id=${pkg.id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }
      
      const result = await response.json();
      if (result.status === 'success') {
        setPackageFeatures(result.data);
      }
    } catch (error) {
      console.error('Error fetching package features:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFeatureToggle = async (featureId, isIncluded) => {
    try {
      const updatedFeatures = packageFeatures.map(f => 
        f.id === featureId ? { ...f, is_included: isIncluded ? 1 : 0 } : f
      );
      setPackageFeatures(updatedFeatures);

      const response = await fetch(API_URLS.ADMIN.UPDATE_PRO_PACKAGE_FEATURES, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          package_id: pkg.id,
          features: updatedFeatures.map(f => ({
            feature_id: f.id,
            is_included: f.is_included == 1
          }))
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned non-JSON response');
      }

      const result = await response.json();
      if (result.status === 'success') {
        onUpdate();
      } else {
        alert('Error: ' + result.message);
        fetchPackageFeatures(); // Revert on error
      }
    } catch (error) {
      console.error('Error updating feature:', error);
      alert('Error updating feature');
      fetchPackageFeatures(); // Revert on error
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
          <div className="flex items-center justify-center h-32">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{pkg.name} - Özellik Yönetimi</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-3">
          {packageFeatures.map((feature) => (
            <div key={feature.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">{feature.title}</h3>
                {feature.description && (
                  <p className="text-sm text-gray-600 mt-1">{feature.description}</p>
                )}
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleFeatureToggle(feature.id, feature.is_included != 1)}
                  className={`p-2 rounded-lg ${
                    feature.is_included == 1 
                      ? 'bg-green-100 text-green-600 hover:bg-green-200' 
                      : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                  }`}
                >
                  {feature.is_included == 1 ? (
                    <CheckCircle className="w-5 h-5" />
                  ) : (
                    <XCircle className="w-5 h-5" />
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminProEcommercePackages;
